import React, {Component} from 'react';

const styles = {
    container: {
        fontSize: '1.2rem',
        lineHeight: 1.5,
        margin: '0 auto',
        maxWidth: 800,
        padding: '0 1rem',
    },
    header: {
        textAlign: 'center',
    },
    summary: {
        fontWeight: 'bold',
        marginBottom: '1rem',
    },
};

let _this;

class SigmaSpeaksPrivacyPolicy extends Component {
    constructor(props, context) {
        super(props, context);
        _this = this;
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="container">
                <div className="fast_nav container">
                    <ul>
                        <li className="first">
                            <a href="#" role="button"
                               onClick={() => _this.props.navigate('Products')}>2025 © AnswerSolutions LLC</a>
                        </li>
                        <li>
                            <a href="#sigma-speaks-product" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksProduct')}>Sigma Speaks</a>
                        </li>
                        <li className="selected">
                            <a href="#sigmaspeakspolicy" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksPolicy')}>Privacy Policy</a>
                        </li>
                        <li>
                            <a href="#sigmaspeakseula" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksEULA')}>User Agreement</a>
                        </li>
                        <li>
                            <a href="#sigmaspeaksSupport" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksSupport')}>Support</a>
                        </li>
                    </ul>
                </div>
                <br/>
                <div>
                    <img style={{borderRadius: '10%'}} className="roundrect" src="/sigma_speaks_artwork.png" align="left"
                         hspace="10" vspace="10" alt="app icon"
                         width="128"/>
                    <br/>
                    <h2>Sigma Speaks: Audio News Daily</h2>
                    <h3>Tailored for Retail Investors</h3>
                </div>
                <br/>
                <br/>
                <br/>
                <div style={styles.container}>
                    <div style={{marginBottom: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '10px', border: '1px solid #e9ecef'}}>
                        <h2 style={{color: '#0d6efd'}}>Project Status: Validation Phase</h2>
                        <p style={{fontSize: '16px', lineHeight: '1.6'}}>
                            <strong>Sigma Speaks is currently in validation state.</strong> Access is available exclusively through:
                        </p>
                        <ul style={{marginLeft: '20px', marginTop: '10px', marginBottom: '15px'}}>
                            <li style={{marginBottom: '8px'}}>
                                <strong>iOS TestFlight Beta:</strong> <a href="https://testflight.apple.com/join/kzNZGq4A" target="_blank" rel="noopener noreferrer">download from testflight</a>
                            </li>
                            <li style={{marginBottom: '8px'}}>
                                <strong>Google Play Beta Program</strong> <a href="https://play.google.com/apps/testing/com.answersolutions.sigmaspeak" target="_blank" rel="noopener noreferrer">download from google play beta</a>
                            </li>
                        </ul>
                        <p style={{fontSize: '16px', lineHeight: '1.6'}}>
                            Alternatively, you can listen to our daily "Sigma Speaks Show" featuring top market stories on:
                        </p>
                        <ul style={{marginLeft: '20px', marginTop: '10px'}}>
                            <li style={{marginBottom: '8px'}}>
                                <strong>Apple Podcasts:</strong> <a href="https://podcasts.apple.com/us/podcast/sigma-speaks/id1851266467" target="_blank" rel="noopener noreferrer">https://podcasts.apple.com/us/podcast/sigma-speaks/id1851266467</a>
                            </li>
                            <li style={{marginBottom: '8px'}}>
                                <strong>Spotify:</strong> <a href="https://open.spotify.com/show/7hz2cM5DfbbTv26ppMbfdR" target="_blank" rel="noopener noreferrer">https://open.spotify.com/show/7hz2cM5DfbbTv26ppMbfdR</a>
                            </li>
                        </ul>
                        <p style={{fontSize: '16px', lineHeight: '1.6', marginTop: '15px'}}>
                            We appreciate your interest and feedback as we continue to improve the Sigma Speaks experience!
                        </p>
                    </div>
                    <h1 style={styles.header}>Privacy Policy</h1>
                    <div>
                        <p>
                            This Privacy Policy describes how AnswerSolutions LLC ("we," "us," or "our") collects, uses,
                            and
                            shares information about you when you use our mobile application and website (collectively,
                            the
                            "Services"). By accessing or using our Services, you agree to be bound by this Privacy
                            Policy.
                            If you do not agree to this Privacy Policy, please do not use our Services.
                        </p>
                        <p style={styles.summary}>
                            Summary: We collect information that you provide to us, such as your email and phone model,
                            for
                            support purposes. We do not collect personal data automatically, and no login or account
                            creation is required to use the Services. Your information is used to improve the Services
                            and
                            provide support. We do not share your information unless required by law.
                        </p>
                        <p>
                            Information We Collect: We only collect information that you provide voluntarily when you
                            use
                            our Services, such as when you contact us for support. The information we may collect
                            includes
                            your email address and phone model, which are provided manually by you when reaching out to
                            us
                            for support. No other personal data is collected automatically.
                        </p>
                        <p>
                            How We Use Your Information: The information we collect is used solely to provide customer
                            support, respond to your inquiries, and improve our Services. We may contact you via email
                            to
                            resolve any issues or answer questions you have. We do not use your information for any
                            other
                            purposes.
                        </p>
                        <p>
                            We do not automatically collect or store any other personal data such as browsing history,
                            location data, or usage patterns. No login or authentication process is required to use the
                            Services, and no accounts are created.
                        </p>
                        <p>
                            Third-Party Services: Our Services may interact with third-party providers such as OpenAI,
                            Google, Apple, Amazon Web Services (AWS), and mobile providers. These third-party services
                            may
                            process certain data to facilitate the operation of the Services. However, we do not collect
                            or
                            share any personal data unless explicitly provided by you for support purposes.
                        </p>
                        <p>
                            Data Retention and Security: We retain the information you provide only as long as necessary
                            for
                            the purposes of providing support and improving the Services. We take reasonable steps to
                            protect your information from unauthorized access or disclosure. However, no method of
                            transmission over the internet or method of electronic storage is completely secure, so we
                            cannot guarantee the absolute security of your data.
                        </p>
                        <p>
                            Children's Privacy: Our Services are not directed to children under the age of 13. If you
                            are a
                            parent or guardian and believe that your child has provided us with personal information
                            without
                            your consent, please contact us at support@answersolutions.net to request the deletion of
                            that
                            information.
                        </p>
                        <p>
                            Changes to This Policy: We may update this Privacy Policy from time to time. If we make
                            material
                            changes, we will notify you via email or post a notice on our website before the changes
                            take
                            effect. Your continued use of our Services after the effective date of the changes
                            constitutes
                            your acceptance of the revised Privacy Policy.
                        </p>
                        <h2>Financial News Content and Data Sources</h2>
                        <p>
                            Sigma Speaks delivers financial news and market updates from various reputable sources. 
                            We aggregate publicly available financial news and information to provide you with timely 
                            and relevant updates about your portfolio holdings and the broader market. All content is 
                            properly attributed to its original source in accordance with fair use principles.
                        </p>
                        <p>
                            Sigma Speaks is committed to respecting intellectual property rights. Our AI narration 
                            technology transforms written content into audio format while maintaining the integrity 
                            of the original information. We work with data providers to ensure compliance with all 
                            applicable licensing requirements and terms of service.
                        </p>

                        <p>
                            Contact Us: If you have any questions or concerns about this Privacy Policy or our data
                            practices, please contact us at support@answersolutions.net.
                        </p>
                    </div>

                    <br/>
                    <br/>
                    <br/>
                    <div className="fast_nav container">
                        <ul>
                            <li className="first">
                                2025 © AnswerSolutions LLC
                            </li>
                            <li>
                                <a href="#Products" role="button"
                                   onClick={() => _this.props.navigate('Products')}>Products</a>
                            </li>
                            <li >
                                <a href="#sigma-speaks-product" role="button"
                                   onClick={() => _this.props.navigate('SigmaSpeaksProduct')}>Sigma Speaks</a>
                            </li>
                            <li className="selected">
                                <a href="#sigmaspeakspolicy" role="button"
                                   onClick={() => _this.props.navigate('SigmaSpeaksPolicy')}>Privacy Policy</a>
                            </li>
                            <li>
                                <a href="#sigmaspeakseula" role="button"
                                   onClick={() => _this.props.navigate('SigmaSpeaksEULA')}>User Agreement</a>
                            </li>
                            <li>
                                <a href="#sigmaspeaksSupport" role="button"
                                   onClick={() => _this.props.navigate('SigmaSpeaksSupport')}>Support</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default SigmaSpeaksPrivacyPolicy;
